import { AuthenticatedAPI } from '../../core-apis/src/apis/config/api/authenticatedApi'

const baseApiUrl = process.env.WIGGOT_FILES_URL ?? ''

class FilesBasicApi extends AuthenticatedAPI {
  constructor() {
    super({
      domain: baseApiUrl,
      apiKey: '15fd2541-a3ad-4e59-98e9-b366bb89f2f9',
      useInterceptors: false
    })
  }
}

export const filesBasicApi = new FilesBasicApi()
